export default "__VITE_ASSET__CvDwbmJB__"